import { api } from './api';
import { GlossaryTerm, GlossaryCategory } from '../types/glossary.types';

export const glossaryService = {
  async getAllTerms(): Promise<GlossaryTerm[]> {
    const response = await api.get('/earlystage/glossary/terms');
    return response.data;
  },

  async getTermById(id: number): Promise<GlossaryTerm> {
    const response = await api.get(`/earlystage/glossary/terms/${id}`);
    return response.data;
  },

  async getTermByName(term: string): Promise<GlossaryTerm> {
    const response = await api.get(`/earlystage/glossary/terms/by-name/${encodeURIComponent(term)}`);
    return response.data;
  },

  async getCategories(): Promise<GlossaryCategory[]> {
    const response = await api.get('/earlystage/glossary/categories');
    return response.data;
  },

  async getTermsByCategory(category: string): Promise<GlossaryTerm[]> {
    const response = await api.get(`/earlystage/glossary/categories/${encodeURIComponent(category)}/terms`);
    return response.data;
  },

  async searchTerms(query: string): Promise<GlossaryTerm[]> {
    const response = await api.get('/earlystage/glossary/search', {
      params: { q: query }
    });
    return response.data;
  }
};
